<template>
    <modal class="splitOrderModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">拆菜操作</div>
        <div class="modal-body">
            <div class="clearfix" ref="recharRight">
                <div class="left-box">
                    <div class="title">基本信息</div>
                    <div class="tr-li">
                        <div class="lable-txt">菜品名称：</div>
                        <div class="from-input" style="width:310px">
                            <input type="text"  readonly :value="disRadioOrder?.EAT_XFName" />
                        </div>
                    </div>
                    <div class="tr-li">
                        <div class="lable-txt">点单数量：</div>
                        <div class="from-input" style="width:115px"><input type="text" placeholder="0"  readonly :value="disRadioOrder?.Eat_Number" /></div>
                        <div class="lable-txt">拆分数量：</div>
                        <div class="from-input" style="width:115px">
                            <input-pattern placeholder="0" class="key-focus" ref="input" 
                                data-model='orderNum' pattern="number" :max="disRadioOrder?.Eat_Number"
                                :dplaces="numDplaces" 
                                isFocSelect
                                v-model="orderNum"/>
                        </div>
                    </div>
                </div>
                <div class="right-box">
                    <div class="keyboard">
                        <div class="key-li"><span data-value="7">7</span><span data-value="8">8</span><span
                                data-value="9">9</span></div>
                        <div class="key-li"><span data-value="4">4</span><span data-value="5">5</span><span
                                data-value="6">6</span></div>
                        <div class="key-li"><span data-value="1">1</span><span data-value="2">2</span><span
                                data-value="3">3</span></div>
                        <div class="key-li"><span data-value=".">.</span><span data-value="0">0</span><span
                                data-value="back"><i class="iconfont icon-zuojiantou"></i></span></div>
                    </div>
                </div>
            </div>
            <div class="tip-box">
                <!--提示：此处显示提示文本，没有提示则不显示-->
            </div>
        </div>
        <div class="footer-box">
            <button class="btn btn-cancel" @click="hide()">取消</button>
            <button class="btn btn-confirm" @click="confirm()">确认</button>
        </div>
  </modal>
</template>

<script>
import {initKeyBoard} from '/src/common' 

export default {
    name:'giveReturnModel',
    emits:["confirm","close"],
    props:{
        isShow:Boolean,
        //要操作的菜
        disRadioOrder:{
            type:Object,
            default:null
        },
        //订单信息
        orderInfo:{
            type:Object,
            default:null
        },
        //是否在结账界面
        isCheckOut:{
            type:Boolean,
            default:false
        },
        //是否联台
        unionType:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        /**小数点后几位 */
        numDplaces(){
            if(this.disRadioOrder?.OnlySupportIntNum){//是否取整
                return 0;
            }
            return null;//不限制
        }
    },
    data(){
        return{
            orderNum:'',
            reasontype:0,
            reasontContent:'',
            /**辅助数量 */
            assSizeNum:'',
             /**用户数据 */
            userInfo:'',
            RefundReasonsList:'',
            /**考虑到联台情况获取对应时间戳 */
            Timestamps:''
        }
    },
    mounted(){
        this.$nextTick(()=> {
            this.Time()
            
            initKeyBoard.call(this,this.$refs.recharRight);
            this.orderNum=this.disRadioOrder?.Eat_Number;
            
            setTimeout(()=>{
                this.$refs.input?.focus();
            },100)
        })
    },
    watch:{
        isShow(){
            if(this.isShow==true){
                this.Time();
                this.reasontype=0;
               
                this.orderNum=this.disRadioOrder?.Eat_Number
                this.$nextTick(()=> {
                    this.$refs.input?.focus();
                })
            }
        },
        orderNum(){
            if(Number(this.orderNum)<0){
                this.orderNum=0
            }
        },
        assSizeNum(){
            if(Number(this.assSizeNum)<0){
                this.assSizeNum=0
            }
        }
    },
    methods:{
        hide(){
            sessionStorage.removeItem("tempUserID")
            sessionStorage.removeItem("tempName")
            this.$emit("close");
        }, 
        confirm(){
            this.userInfo=this.$auth.getUserInfo(); //获取用户id
           
            let param={
                User_ID:this.userInfo?.User_ID,
                Operator_Name:this.userInfo?.Login_Name,
                Eat_ConsumeID:this.disRadioOrder.Eat_ConsumeID, //菜品明细ID
                Eat_Number:this.orderNum,//拆分数量，必须大于0且小于该明细剩余数量
                IsReturn_CheckOutInfo:true,//是否返回完整结账页订单信息
                Is_UnionOrder:this.unionType,//是否是联台结账的
                Timestamps:this.Timestamps
            }
            if(sessionStorage.getItem("tempUserID")){
                param.User_ID = sessionStorage.getItem("tempUserID")
                param.Operator_Name = sessionStorage.getItem("tempName")
                sessionStorage.removeItem("tempUserID")
                sessionStorage.removeItem("tempName")
            }
            
            /**拆菜 */
            if(this.disRadioOrder.Eat_Number<=param.Eat_Number || !(this.disRadioOrder.Eat_Number>0)){
                this.$alert('拆菜数量必须大于0且小于点单数量!请修改拆菜数量', '提示', {
                    confirmButtonText: '确定',
                    callback: () => {
                        this.$refs.input.focus();
                    },
                });
            }else{
                const loading = this.$loading({
                    text: "拆菜中...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)",
                });
                this.$httpAES.post("Bestech.CloudPos.SplitOrderConsume",param).then((data)=>{
                    loading.close();
                    if(data.ResponseHeader.ResultCode!=0){
                        this.$message.error(data.ResponseHeader.ResultDesc);
                    }else{
                        this.$message.success({ message: "拆菜成功"});
                        this.$emit("confirm",data.ResponseBody)
                    }
                }).catch((e)=>{
                    loading.close();
                    this.$alert(e.message, "提示", {confirmButtonText: "确定"});
                })
            }
        },
       
        /**获取订单时间戳 */
        Time(){
            this.Timestamps=''
            this.orderInfo.Order_ConsumeList.forEach(order=>{
                this.Timestamps = this.orderInfo.Timestamps.toString()
                if(order.Eat_TcItemList){
                    order.Eat_TcItemList.map(eat=>{
                        if(eat.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                            this.Timestamps = this.orderInfo.Timestamps.toString()
                        }
                    })
                }else{
                    if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                        this.Timestamps = this.orderInfo.Timestamps.toString()
                    }
                }
            })
            if(this.orderInfo.UnionOrderInfoList){
                this.orderInfo.UnionOrderInfoList.forEach(union=>{
                    union.Order_ConsumeList.forEach(order=>{
                        if(order.Eat_TcAutoID_Batch){
                            //如果是退菜,并且是联台套餐子项退菜
                            order.Eat_TcItemList.map(eat=>{
                                if(eat.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                    this.Timestamps = union.Timestamps.toString()
                                }
                            })
                        }else{
                            if(order.Eat_ConsumeID==this.disRadioOrder.Eat_ConsumeID){
                                    this.Timestamps = union.Timestamps.toString()
                            }
                        }
                        
                    })
                })
            }
        },
    }
}
</script>

<style lang="scss">
@import './splitOrderModel.scss';
</style>